import { useEffect } from "react";
import { logEvent, setUserProperties } from "firebase/analytics";
import { useLocation } from "react-router-dom";
import { analytics } from "App";
import { useAppSelector } from "store";
import packageJson from "../../../package.json";

export const useFirebaseRoutesAnalytics = (): null => {
  const location = useLocation();
  const { versao } = useAppSelector((state) => state);
  useEffect(() => {
    logEvent(analytics, "screen_view", {
      firebase_screen: `${window.location.hostname}${location.pathname}`,
      firebase_screen_class: "firebase-routes-analytics",
      app_version: versao.app,
      app_name: packageJson.name,
    });
    setUserProperties(analytics, { app_version: versao.app });
    setUserProperties(analytics, { app_name: packageJson.name });
  }, [location]);

  return null;
};
